import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon';
import StartedRoutines, {
  STARTED_ROUTINES_TITLE,
  STARTED_ROUTINES_ICON_TYPE,
} from './StartedRoutines';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { IWidgetContentProps } from '../../../../Dashboard/Components/Widget/Widget';

const useStyles = makeStyles()((theme: Theme) => ({
  startPanelWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: `calc(70vh - ${theme.spacing(0)})`,
    boxShadow: theme.customProperties.Shadows.bottomShadow,
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
    },
  },
}));

const StartedRoutinesPanel: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = props => {
  const { classes } = useStyles();
  return (
    <div className={classes.startPanelWrapper}>
      <EDPanel
        title={STARTED_ROUTINES_TITLE}
        avatar={
          <EDIcon
            color="action"
            iconType={STARTED_ROUTINES_ICON_TYPE}
            size="large"
          />
        }
        headerPadding="normal"
        flex
        testId="startedRoutinesPanel"
      >
        <StartedRoutines hideLeveransstatus />
      </EDPanel>
    </div>
  );
};

export const StartedRoutinesWidget: React.FC<IWidgetContentProps> = props => {
  return <StartedRoutines hideLeveransstatus />;
};

export default StartedRoutinesPanel;
